const { nameValidate } = require('./name')

module.exports = function (value, data) {
  const { passengerType, lastName = '', firstName = '', passengerFirstName = '', passengerLastName = '' } = data
  const fullName = (lastName && firstName) ? lastName + firstName : passengerLastName + passengerFirstName
  return nameValidate(fullName, true, false, passengerType)
}
